'use strict';

var debounce = require('lodash/debounce');

var breakpoints = {
    mobile: 0,
    tablet: 768,
    desktop: 1200
};

var customCarousels;

/**
 * Calculate the custom carousel's height to avoid having tiles of different sizes
 * @param {jQuery} element - the current custom carousel that are being used
 */
function setCustomCarouselHeight(elements) {
    if (elements?.length) {
        elements.each(function (index, element) {
            var carouselItems = $(element).find('.carousel-item');
            carouselItems.removeAttr('style');
            // If the carousel is hidden in mobile, don't update the height
            carouselItems.css({ display: 'block', visibility: 'hidden' });
            var maxElHeight = -1;
            carouselItems.each(function () {
                if ($(this).height() > maxElHeight) {
                    maxElHeight = $(this).height();
                }
            });
            carouselItems.height(maxElHeight);
            carouselItems.css({ display: '', visibility: '' });
        });
    }
}

/**
 * Show/hide carousel control buttons depending on current position
 * @param {jQuery} element - the current custom carousels that are being used
 */
function updateCarouselStatus(elements, event) {
    if (elements?.length) {
        elements.each(function (index, element) {
            var maximumSlidesPerView = $(element).data('max-per-view');
            var slidesPerView = {};
            slidesPerView[breakpoints.desktop] = maximumSlidesPerView || 1;
            slidesPerView[breakpoints.tablet] = maximumSlidesPerView - 1 > 0 ? maximumSlidesPerView - 1 : 1;
            slidesPerView[breakpoints.mobile] = maximumSlidesPerView - 2 > 0 ? maximumSlidesPerView - 2 : 1;
            var numberOfVisibleItems = $(element).find('.carousel-item').length;
            // Number of slides visible for the current view
            var shownSlides =
                slidesPerView[
                    Object.keys(slidesPerView).reduce((acc, val) => {
                        var intValue = parseInt(val, 10);
                        if (intValue && intValue > acc && intValue < $(window).width()) {
                            return intValue;
                        }
                        return acc;
                    }, 0)
                ] || 1;
            var elementsToHideIfAllVisible = $(element).find('.carousel-item--hide-all-visible');
            if (elementsToHideIfAllVisible.length) {
                if (shownSlides >= numberOfVisibleItems - elementsToHideIfAllVisible.length) {
                    elementsToHideIfAllVisible.addClass('d-none');
                    numberOfVisibleItems -= elementsToHideIfAllVisible.length;
                } else {
                    elementsToHideIfAllVisible.removeClass('d-none');
                }
            }
            if (!$(element).hasClass('custom-carousel--no-mobile') || $(window).width() >= breakpoints.tablet) {
                var targetItem = $(element).find('.carousel-item.active').index();

                // Last visible element
                targetItem += Math.min(shownSlides, numberOfVisibleItems);
                if (event?.direction === 'left') {
                    // If the end is reached, cancel scroll event
                    if (targetItem >= numberOfVisibleItems) {
                        event.preventDefault();
                    } else {
                        targetItem++;
                    }
                } else if (event?.direction === 'right') {
                    targetItem--;
                }
                var buttonPrev = $(element).find('.carousel-control-prev');
                var buttonNext = $(element).find('.carousel-control-next');
                // If the last visible element's position we have is less than the number of items visible for
                // the currect view, hide the left arrow button
                if (targetItem <= shownSlides) {
                    buttonPrev.addClass('d-none');
                } else {
                    buttonPrev.removeClass('d-none');
                }
                // If we have reached the end of the carousel, hide the right arrow button
                if (targetItem >= numberOfVisibleItems) {
                    buttonNext.addClass('d-none');
                } else {
                    buttonNext.removeClass('d-none');
                }
            }
        });
    }
}

$(document).ready(function () {
    customCarousels = $('.custom-carousel');

    setCustomCarouselHeight(customCarousels);
    updateCarouselStatus(customCarousels);

    customCarousels.on('slide.bs.carousel', function (e) {
        updateCarouselStatus($(e.currentTarget), e);
    });

    $(window).on(
        'resize',
        debounce(function () {
            setCustomCarouselHeight(customCarousels);
            updateCarouselStatus(customCarousels);
        }, 500)
    );
});

$(window).on('load', function () {
    setCustomCarouselHeight(customCarousels);
    updateCarouselStatus(customCarousels);
});
